// src/firebase.js
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAEji8Yusmd_IPGivdHWIycOkTNsDNs5GM",
  authDomain: "actnet-events.firebaseapp.com",
  databaseURL: "https://actnet-events-default-rtdb.firebaseio.com",
  projectId: "actnet-events",
  storageBucket: "actnet-events.firebasestorage.app",
  messagingSenderId: "734523008173",
  appId: "1:734523008173:web:2da3b11426dc4bd7469224",
  measurementId: "G-MFH1E0SE7E",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getDatabase(app);
console.log(
  getApps().length ? "✅ Firebase connected" : "❌ Firebase not connected"
);
